//import {detect} from 'detect-browser';
import Component from '../abstracts/Component';

export default class LayersMenuSwitch extends Component {

  get SELECTORS() {
    return {
      main: '[data-handler="menu-layers"]',
      desktop: '[data-nav="desktop"]',
      navBtn: '#js-navBtn',
      mobile: '[data-nav="mobile"]',
      mobileBack: '.mobile-btns__back',
      closeBtns: '.jsCloseBtn',
      openNavs: 'open-nav',
      actions: '[data-nav="actions"]',
      menuLayersContainer: '#menu-layers-container',
      menuLayers: '.jsLayer',
      actionsLayersContainer: '#action-layers-container',
      allContainers: '.show-container',
      activeItemMenu: '.active',
      itemSubPages: '.l-m-nov__links'
    };
  }

  isActionNav(element){
    let navAction = document.querySelector(this.SELECTORS.actions);
    return navAction.contains(element);
  }

  constructor() {
    super();
    this.activeClassBtns='active';
    this.showPanelClass = 'show-panel';
    this.showContainerClass = 'show-container';
    this.menuLayerClass = 'l-menu-panel';
  }

  showLayersContainer(containerEl, isVisible) {
    let contEl = containerEl;
    let visible = isVisible;
    let cssClass = this.showContainerClass;
    if (visible) {
      contEl.classList.add(cssClass);
    } else {
      contEl.classList.remove(cssClass);
    }
  }

  showLayer(el, name) {
    if (el.dataset.menuLayer === name) {
      el.classList.add(this.showPanelClass);
    } else {
      el.classList.remove(this.showPanelClass);
    }
  }

  hideEveryLayer() {
    let layersEls = document.querySelectorAll(this.SELECTORS.menuLayers);
    for (let i = 0; i < layersEls.length; i++) {
      layersEls[i].classList.remove(this.showPanelClass);
    }
  }

  hideEveryContainer() {
    let allContainers = document.querySelectorAll(this.SELECTORS.allContainers);
      for (let cont of allContainers) {
        cont.classList.remove(this.showContainerClass);
      }
  }

  getLayer(layer, layerContainer) {
    let isClickable = false;
    const layerContainerEl = layerContainer;
    let menuLayers = document.querySelectorAll(this.SELECTORS.menuLayers);
    let layerEl = layer.dataset.menuTarget;
    //check if nav has subpages to show, if not do not show layer
    let navElement = layerContainerEl.querySelectorAll('[data-menu-layer='+layerEl+']')[0];
    let showLayer = true;
    if(navElement != null && navElement.dataset.showLayer != null) {
      showLayer = navElement.dataset.showLayer == 'true' ? true : false;
    }
    if (typeof layerEl !== 'undefined' && showLayer == true) {
      this.showLayersContainer(layerContainerEl, true);

    } else {
      this.showLayersContainer(layerContainerEl, false);
      isClickable = true;
    }
    layerContainerEl.dataset.layerJs = layerEl;
    this.$emit(this.$customEvents.MINICART_EVENTS.open, {content: layerEl, ctx: this});
    for (let i = 0; i < menuLayers.length; i++) {
      this.showLayer(menuLayers[i], layerEl);
    }
    return isClickable;
  }

  setInactiveMenuItems() {
    let itemsEl = document.querySelectorAll(`.c-header ${this.SELECTORS.activeItemMenu}`);
    for (let i = 0; i < itemsEl.length; i++) {
      itemsEl[i].classList.remove(this.activeClassBtns);
    }
  }

  menuHandler(menuType) {
    const allNavs = document.querySelectorAll(menuType);

    let layerContainer = null;

    for (let navElement of allNavs) {
      if (navElement.dataset.nav === 'actions') {
        layerContainer = document.querySelector(this.SELECTORS.actionsLayersContainer);
      } else {
        layerContainer = document.querySelector(this.SELECTORS.menuLayersContainer);
      }

      let navItems = navElement.children;
      let isMobile = window.matchMedia('(max-width:767px)');

      for (let item of navItems) {
        if(isMobile.matches){
          this.$on('click', this.openLayerEvent, item, null, {ctx: this, layerContainer: layerContainer});
        } else {
          this.$on('click', this.openLayerEvent, item, null, {ctx: this, layerContainer: layerContainer});
          this.$on('mouseenter', this.openLayerEvent, item, null, {ctx: this, layerContainer: layerContainer});
        }

        let isQuickCart = item.classList.contains('action--quickcart');
        if(isQuickCart){
          this.$on(this.$customEvents.PRODUCT_EVENTS.addedtocart,()=>{
            setTimeout(()=>{
              this.hideEveryContainer();
              this.setInactiveMenuItems();

              this.getLayer(item, layerContainer);
            },750);

          });
        }
        //add listener for custom event trigger
        $(item).on(this.$customEvents.MENU_EVENTS.showMenu, (e) => {
          let isWishlist = item.classList.contains('action--wish');

          this.hideEveryContainer();
          this.setInactiveMenuItems();

          if (!isMobile.matches && isWishlist === false) {
              item.classList.add('active');
          }
          this.getLayer(item, layerContainer);
        });


        this.$on(this.$customEvents.MENU_EVENTS.hideMenu, (e) => {
          setTimeout(()=>{
            this.hideEveryContainer();
            this.setInactiveMenuItems();
          },e.payload.time || 1);
        },
        item);

        if(!isMobile.matches){
          this.$on('click', (e) => {
            if(e.event.target !== e.event.currentTarget) return;
            this.hideEveryContainer();
            this.setInactiveMenuItems();
          },
          '.js-close-layers');
        }

      }
      if (!isMobile.matches) {
        let menuLayers = document.querySelectorAll(this.SELECTORS.menuLayers);
        let customTimeout;
        for(let layer of menuLayers){
          // TODO set when google chrome fix the bug:
          // https://bugs.chromium.org/p/chromium/issues/detail?id=834506
          // https://bugs.chromium.org/p/chromium/issues/detail?id=745468
          //
          this.$on('mouseleave', (e) => {
            try {
              if(!$('.js-account-layer').is(":focus-within")) {
                this.hideEveryContainer();
                this.setInactiveMenuItems();
              }
            } catch (e) {
              this.setInactiveMenuItems();
              layer.classList.remove(this.showPanelClass);
              this.hideEveryContainer();
            }
          },document);
          layer.addEventListener('mouseleave', (e) => {
            try {
              if(!$(layer).is(":focus-within")) {
                this.setInactiveMenuItems();
                layer.classList.remove(this.showPanelClass);
                this.hideEveryContainer();
              }
            } catch (e) {
              this.setInactiveMenuItems();
              layer.classList.remove(this.showPanelClass);
              this.hideEveryContainer();
            }
          });
          layer.addEventListener('mouseenter',(e)=>{
            clearTimeout(customTimeout);
          })
        }
      }
    }
    let itemsEl = document.querySelectorAll(`.c-header ${this.SELECTORS.activeItemMenu}`);
    if (itemsEl.length === 0) {
      this.hideEveryContainer();
    }
    // tap out of panel on mobile devices
    let isDesktop = window.matchMedia('(min-width:1280px)');
    if (!isDesktop.matches) {
      this.setOutsideTap();
    }

    const mobileBackBtn = document.querySelectorAll(this.SELECTORS.mobileBack);
    let closeBtns = document.querySelectorAll(this.SELECTORS.closeBtns);
    //Back btns on mobile
    for (let backBtn of mobileBackBtn) {
      backBtn.addEventListener('click', () => {
        this.showLayersContainer(layerContainer, false);
        this.hideEveryLayer();
      });
    }
    //Close btns on mobile
    for (let btn of closeBtns) {
      btn.addEventListener('click', () => {
        this.closeAllTrigger();
        this.showLayersContainer(layerContainer, false);
        this.hideEveryLayer();
      });
    }
  }

  openLayerEvent(e) {
    console.log('is event '+e.event.type);
    let ctx = e.event.data.ctx;
    const $this = e.event.currentTarget;
    let isWishlist = $this.classList.contains('action--wish');
    const isMobile = window.matchMedia('(max-width:767px)');

    ctx.hideEveryContainer();
    ctx.setInactiveMenuItems();

    if (!isMobile.matches && isWishlist === false) {
        $this.classList.add('active');
    }
    let isClickable = ctx.getLayer($this, e.event.data.layerContainer);
    if (isMobile.matches && !isClickable) {
      e.event.preventDefault();
      e.event.stopPropagation();
    }
  }

  closeAllTrigger() {
    let openallNavsEls = document.querySelectorAll('[data-menu="nav-mobile"]');
    let actionBar = document.querySelector('#actions-desktop');
    let menuBtn = document.querySelector(this.SELECTORS.navBtn);
    for (let nav of openallNavsEls) {
      nav.classList.remove('open-nav');
    }
    menuBtn.classList.remove('active-menu');
    actionBar.classList.remove('hide');
  }

  setOutsideTap() {
    let handler = (e)=>{
      let allOpenedPanels = document.querySelectorAll('.show-container');
      let wrap = null;
      let condition = false;
      for(let openedPanel of allOpenedPanels){
        if (typeof openedPanel!== 'undefined') {
          if( `#${openedPanel.getAttribute('id')}` === this.SELECTORS.menuLayersContainer) {
            // menu layer is open
            wrap = document.querySelector(this.SELECTORS.menuLayersContainer);
            condition = e.target.matches('.show-container');
          }
          if( `#${openedPanel.getAttribute('id')}` === this.SELECTORS.actionsLayersContainer) {
            // actions layer is open
            wrap = document.querySelector(this.SELECTORS.actionsLayersContainer);
            condition= e.target.matches('.show-container');
          }
          let navItems = wrap.children;
          if (condition) {
            // user is clicking on the menu Container but outside contents
            this.setInactiveMenuItems();
            this.hideEveryLayer();
            this.hideEveryContainer();
          }
        }
      }

    }
    window.addEventListener('click', handler);
  }

  render() {
    this.log('Rendering...');
    if (document.querySelectorAll(this.SELECTORS.desktop)) {
      this.menuHandler(this.SELECTORS.desktop);
    }

    if (document.querySelectorAll(this.SELECTORS.actions)) {
      this.menuHandler(this.SELECTORS.actions);
    }
  }
}
